import React from 'react';
import { StyledTrainsInbound } from '../BorderControlRequirement.styles';

const TrainReturnIcon = () => (
  <StyledTrainsInbound
    data-testid="trainReturnIcon"
    data-cy="trainReturnIcon"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_316_3501)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.96 47.7001V45.2401H61.97V12.15V10.3V9.69005V8.46005C61.2859 8.453 57.3147 8.46584 54.7837 8.47402C53.7256 8.47744 52.9193 8.48005 52.71 8.48005C50.45 8.43005 48.03 8.53005 45.72 8.75005C35.92 9.72005 25.72 12.72 18.52 19.77C18.2647 20.0222 17.9961 20.2855 17.7231 20.5532C17.1407 21.1243 16.5379 21.7153 16 22.26C12.64 25.65 9.27997 29.09 6.38997 32.92L6.35927 32.963C5.96906 33.5092 5.57153 34.0656 5.24997 34.66C5.23997 34.675 5.23247 34.69 5.22497 34.705C5.21747 34.72 5.20997 34.735 5.19997 34.75C5.19997 34.75 5.17997 34.77 5.16997 34.8C5.09848 34.9112 5.03961 35.0098 4.97332 35.1209C4.95615 35.1496 4.93848 35.1792 4.91997 35.21C3.66997 37.39 2.48997 39.9901 2.56997 42.5801C2.63997 44.8801 4.01997 46.6701 6.22997 47.3301C7.40997 47.7001 8.65997 47.71 9.86997 47.7001H11.95H61.96ZM15.5 28.08L23.68 19.5H38.24C38.24 19.5 38.14 20.91 37.94 22.2C37.33 24.93 36.41 28.08 33.39 28.08H15.5ZM61.55 54.6501L4.12997 53.2401C3.65997 53.2301 3.27996 53.6001 3.27996 54.0701V56.2101C3.27996 56.6801 3.65997 57.0501 4.12997 57.0401L61.55 55.6301C61.71 55.6201 61.84 55.4901 61.84 55.3301V54.9501C61.84 54.7901 61.71 54.6501 61.55 54.6501Z"
        fill="#00286A"
      />
    </g>
    <g clipPath="url(#clip1_316_3501)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.96 47.7001V45.2401H61.97V12.15V10.3V9.69005V8.46005C61.2859 8.453 57.3147 8.46584 54.7837 8.47402C53.7256 8.47744 52.9193 8.48005 52.71 8.48005C50.45 8.43005 48.03 8.53005 45.72 8.75005C35.92 9.72005 25.72 12.72 18.52 19.77C18.2647 20.0222 17.9961 20.2855 17.7231 20.5532C17.1407 21.1243 16.5379 21.7153 16 22.26C12.64 25.65 9.27997 29.09 6.38997 32.92L6.35927 32.963C5.96906 33.5092 5.57153 34.0656 5.24997 34.66C5.23997 34.675 5.23247 34.69 5.22497 34.705C5.21747 34.72 5.20997 34.735 5.19997 34.75C5.19997 34.75 5.17997 34.77 5.16997 34.8C5.09848 34.9112 5.03961 35.0098 4.97332 35.1209C4.95615 35.1496 4.93848 35.1792 4.91997 35.21C3.66997 37.39 2.48997 39.9901 2.56997 42.5801C2.63997 44.8801 4.01997 46.6701 6.22997 47.3301C7.40997 47.7001 8.65997 47.71 9.86997 47.7001H11.95H61.96ZM15.5 28.08L23.68 19.5H38.24C38.24 19.5 38.14 20.91 37.94 22.2C37.33 24.93 36.41 28.08 33.39 28.08H15.5ZM61.55 54.6501L4.12997 53.2401C3.65997 53.2301 3.27996 53.6001 3.27996 54.0701V56.2101C3.27996 56.6801 3.65997 57.0501 4.12997 57.0401L61.55 55.6301C61.71 55.6201 61.84 55.4901 61.84 55.3301V54.9501C61.84 54.7901 61.71 54.6501 61.55 54.6501Z"
        fill="#106DFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_316_3501">
        <rect width="29" height="49" fill="white" transform="matrix(-1 0 0 1 62 8)" />
      </clipPath>
      <clipPath id="clip1_316_3501">
        <rect width="30" height="49" fill="white" transform="matrix(-1 0 0 1 33 8)" />
      </clipPath>
    </defs>
  </StyledTrainsInbound>
);

export default TrainReturnIcon;
